import apiRequest from 'client/helpers/apiRequest';
import { OutreachEntity, Dataset, OutreachEntityType } from '@interfaces/outreach-entity';
import ListResponse from '@interfaces/list-response';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

export type OutreachResponseList<T> = ListResponse<OutreachEntity<T>>;
export type DatasetList = OutreachResponseList<Dataset>;

export function fetchDatasetsPage(requestParams: OutreachRequestParams = {}): Promise<DatasetList> {
    const { page: pageNumber = 1, pageSize = 5, year } = requestParams;

    const params: any = { pageNumber, pageSize };
    if (year) {
        params.year = year;
    }

    return apiRequest.get<DatasetList>(`/api/outreach/${OutreachEntityType.dataset}`, { params });
}

export function fetchDatasetsFilters(): Promise<YearsFilter> {
    return apiRequest.get<YearsFilter>(`/api/outreach/${OutreachEntityType.dataset}/filters`);
}
